module.exports = ".bg-red {\n  background-color: #dc3545; }\n"